/**
 * Spectrum Theme Sound Configuration
 *
 * Cyberpunk/futuristic sounds for the Spectrum 3D board theme
 * Uses custom finisher sound, defaults for everything else
 */

import spectrumMovementSound from '../../../../assets/sounds/themes/spectrum/spectrum-movement.wav';
import spectrumFinisherSound from '../../../../assets/sounds/themes/spectrum/spectrum-finisher.wav';
import spectrumLineClearSound from '../../../../assets/sounds/themes/spectrum/spectrum-lineclear.wav';
import spectrumHardDropSound from '../../../../assets/sounds/themes/spectrum/spectrum-harddrop.wav';
import rotateBlockSoundPath from '../../../../assets/sounds/rotateBlockTrimmed.wav';

export const SPECTRUM_SOUND_CONFIG = {
  name: 'Spectrum',
  description: 'Cyberpunk-themed sounds for Spectrum board',

  // Theme sound definitions
  sounds: {
    // Movement sound for piece movements (left/right/down/rotate)
    movement: {
      src: spectrumMovementSound,
      volume: 0.4,
      rate: 1.0
    },

    // Hard drop sound
    hardDrop: {
      src: spectrumHardDropSound,
      volume: 0.5,
      rate: 1.0
    },

    // Line clear sound for single line clears
    lineClear: {
      src: spectrumLineClearSound,
      volume: 0.5,
      rate: 1.0
    },

    // Epic finisher sound for multi-line clears (2+ lines)
    finisher: {
      src: spectrumFinisherSound,
      volume: 0.6,
      rate: 1.0
    },

    // Failed rotation sound
    rotateBlock: {
      src: rotateBlockSoundPath,
      volume: 0.5,
      rate: 1.0
    }
  },

  /**
   * Mappings from game sound keys to theme sound keys
   *
   * Game sound keys (from utilities.js):
   * - fall: Piece movement (left/right/down/rotate success)
   * - rotateBlockSound: Failed rotation attempt
   * - whipSound: Hard drop impact
   * - blasterSound: Line clear laser effect
   * - deliciousSound: Tetris (4-line clear) celebration
   *
   * Set to null to use default sound (no theme override)
   */
  mappings: {
    fall: 'movement',              // Movement → spectrum movement
    rotateBlockSound: 'rotateBlock', // Failed rotation → rotateBlock.wav
    whipSound: 'hardDrop',         // Hard drop → spectrum hard drop
    blasterSound: 'lineClear',     // Single line clear → spectrum line clear
    deliciousSound: 'finisher'     // Tetris finisher → spectrum finisher
  }
};

export default SPECTRUM_SOUND_CONFIG;
